import SidePanelGraphPresets from './SidePanelGraphPresets';

export default SidePanelGraphPresets;
